// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.payment.PaymentManualInvoiceSearchRequest */
/* istanbul ignore next */
@GandalfModel
export class PaymentManualInvoiceSearchRequest extends GandalfModelBase {

	@GandalfLabel('Claim Submit Date End')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	claimDateEnd!: Date | null;

	@GandalfLabel('Claim Submit Date Start')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	claimDateStart!: Date | null;

	@GandalfLabel('Claim #')
	@GandalfValidator({ max: { max: 999999999999999999, message: 'Claim # may not be more than 18 digits' } })
	@GandalfProperty({ designType: Number })
	claimId!: number | null;

	@GandalfLabel('Invoice Date End')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	invoiceDateEnd!: Date | null;

	@GandalfLabel('Invoice Date Start')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	invoiceDateStart!: Date | null;

	@GandalfLabel('Invoice #')
	@GandalfValidator({ max: { max: 999999999999999999, message: 'Invoice # may not be more than 18 digits' } })
	@GandalfProperty({ designType: Number })
	invoiceId!: number | null;

	@GandalfLabel('Location')
	@GandalfProperty({ designType: Number })
	locationId!: number | null;

	@GandalfLabel('Patient #')
	@GandalfValidator({ max: { max: 999999999999999999, message: 'Patient # may not be more than 18 digits' } })
	@GandalfProperty({ designType: Number })
	patientId!: number | null;

	@GandalfLabel('Patient Name')
	@GandalfValidator({ sizeString: { fieldLabel: 'Patient Name', maxLength: 1000, minLength: 0, message: 'Patient Name must be less than or equal to 1000 characters' } })
	@GandalfProperty({ designType: String })
	patientLastName!: string | null;

	@GandalfLabel('Insurance Type')
	@GandalfProperty({ designType: Number })
	payerInsuranceType!: number | null;

	@GandalfLabel('Payer Name')
	@GandalfValidator({ notNull: { message: 'Payer Name is required' } })
	@GandalfValidator({ sizeString: { fieldLabel: 'Payer Name', maxLength: 1000, minLength: 0, message: 'Payer Name must be less than or equal to 1000 characters' } })
	@GandalfProperty({ designType: String, isRequired: true })
	payerName!: string;

	@GandalfConstantDecorator(constants.PayerType)
	@GandalfLabel('Payer Type')
	@GandalfValidator({ notNull: { message: 'Payer Type is required' } })
	@GandalfProperty({ designType: constants.PayerType, isRequired: true })
	payerType!: constants.PayerType;

	@GandalfLabel('Provider')
	@GandalfProperty({ designType: Number })
	providerId!: number | null;

	@GandalfLabel('Service Date End')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	serviceDateEnd!: Date | null;

	@GandalfLabel('Service Date Start')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	serviceDateStart!: Date | null;

}
